var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectionNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_285_1577)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 0C18.45 0 18 0.45 18 1V9.01C18.69 9.05 19.36 9.18 20 9.37V1C20 0.45 19.55 0 19 0ZM13 4.99999C13.55 4.99999 14 5.44999 14 5.99999V9.75999C13.27 10.08 12.6 10.51 12 11.02V5.99999C12 5.44999 12.45 4.99999 13 4.99999ZM6 12V23C6 23.552 6.448 24 7 24C7.552 24 8 23.552 8 23V12C8 11.448 7.552 11 7 11C6.448 11 6 11.448 6 12ZM1 24C1.552 24 2 23.552 2 23V16C2 15.448 1.552 15 1 15C0.448 15 0 15.448 0 16V23C0 23.552 0.448 24 1 24ZM23.9531 17.5078C23.9531 21.0875 21.0406 24 17.4609 24C13.8812 24 10.9688 21.0875 10.9688 17.5078C10.9688 13.9281 13.8812 11.0156 17.4609 11.0156C21.0406 11.0156 23.9531 13.9281 23.9531 17.5078ZM17.4609 22.5018C20.2146 22.5018 22.4549 20.2615 22.4549 17.5078C22.4549 16.4011 22.0814 15.3874 21.4701 14.5584L14.5115 21.516C15.3405 22.1283 16.3543 22.5018 17.4609 22.5018ZM20.4104 13.4996C19.5814 12.8874 18.5676 12.5138 17.4609 12.5138C14.7073 12.5138 12.4669 14.7541 12.4669 17.5078C12.4669 18.6145 12.8405 19.6283 13.4518 20.4573L20.4104 13.4996Z",
    fill: "#DD2F2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_285_1577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionNone);
export default __webpack_public_path__ + "static/media/connection-none.aacb6c031fda2ba44fabd5ef2cb770b6.svg";
export { ForwardRef as ReactComponent };